export default "__VITE_ASSET__BlTBkiAg__"